<template>
    <ui-data-table 
        :p-headers="headers"
        p-title="Tipos de documentos"
        p-read-link="docTypes.read.one"
        p-create-link="docTypes.create"
        p-name="docTypes"
    />
</template>
<script>

import {uiDataTable} from '@/components/ui'
export default {
    name: 'vwDocTypesRead',
    components: {
        uiDataTable  
    },
    data(){
        return {
            headers: [{
                text: 'id',
                value: 'id'
            }, {
                text: 'Descrição',
                value: 'descricao'
            }, {
                text: 'Observações',
                value: 'observacao'
            }, {
                text: 'Cadastrado',
                value: 'criado_em'
            }, {
                text: 'Ações', 
                value: 'actions', 
                sortable: false
            }],
        }
    },
}
</script>